import React from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { GlobalError } from '../GlobalError/GlobalError';
import { useCommonWebTranslation } from '../hooks';
import { NavigationContextProvider } from '../NavigationContext';
import { LoginForm, OktaLoginForm, Page } from './components';
export const LandingApp = (props) => {
    var _a, _b, _c, _d;
    const { t } = useCommonWebTranslation();
    let loginElement;
    if (props.loginElement) {
        loginElement = props.loginElement;
    }
    else if (props.loginFormProps) {
        loginElement = React.createElement(LoginForm, Object.assign({}, props.loginFormProps));
    }
    else if (props.oktaLoginFormProps) {
        loginElement = React.createElement(OktaLoginForm, Object.assign({}, props.oktaLoginFormProps));
    }
    const indexElement = (_a = props.indexElement) !== null && _a !== void 0 ? _a : (React.createElement(Page, Object.assign({}, props, { juvareHref: (_b = props.juvareHref) !== null && _b !== void 0 ? _b : (_c = props.oktaLoginFormProps) === null || _c === void 0 ? void 0 : _c.oktaUrl, contentTitle: props.loginTitle, contentHtml: props.loginHtmlContent, loginElement: loginElement })));
    const pagesWithPath = props.pages.filter((page) => 'path' in page);
    const router = createBrowserRouter([
        {
            path: '/',
            element: React.createElement(Outlet, null),
            errorElement: React.createElement(Page, Object.assign({}, props, { image: undefined, loginElement: undefined, contentElement: React.createElement(GlobalError, null) })),
            children: [
                {
                    index: true,
                    element: indexElement,
                },
                ...pagesWithPath.map((page) => {
                    var _a, _b, _c, _d;
                    return ({
                        path: page.path,
                        element: 'htmlContent' in page ? (React.createElement(Page, Object.assign({}, props, { image: (_a = page.image) !== null && _a !== void 0 ? _a : props.image, loginElement: undefined, contentTitle: (_b = page.title) !== null && _b !== void 0 ? _b : page.label, contentHtml: page.htmlContent, border: true }))) : (React.createElement(Page, Object.assign({}, props, { image: (_c = page.image) !== null && _c !== void 0 ? _c : props.image, loginElement: undefined, contentTitle: (_d = page.title) !== null && _d !== void 0 ? _d : page.label, contentElement: page.customElement }))),
                    });
                }),
                ...((_d = props.routes) !== null && _d !== void 0 ? _d : []).map((route) => {
                    var _a, _b;
                    return (Object.assign(Object.assign({}, route), { element: ((_a = route.handle) === null || _a === void 0 ? void 0 : _a.type) === 'landing' ? (React.createElement(Page, Object.assign({}, props, { image: (_b = route.handle.image) !== null && _b !== void 0 ? _b : props.image, loginElement: undefined, contentTitle: route.handle.title, contentElement: route.element, border: route.handle.border }))) : (route.element) }));
                }),
                {
                    path: '*',
                    element: indexElement,
                },
            ],
        },
        {
            path: '/error',
            element: React.createElement(GlobalError, { description: t('pageError.descriptionPageNotLoaded') }),
        },
    ], {
        basename: props.basename,
    });
    return (React.createElement(NavigationContextProvider, null,
        React.createElement(RouterProvider, { router: router })));
};
